// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cliente-reajuste-igpm-preview .uk-label {
  border-radius: 2px;
}
.cliente-reajuste-igpm-preview table {
  min-width: 1320px;
}
.cliente-reajuste-igpm-de-para-list {
  display: grid;
  gap: 6px;
  min-width: 220px;
}
.cliente-reajuste-igpm-de-para-item {
  display: grid;
  gap: 2px;
  padding: 6px 8px;
  border-left: 3px solid #003768;
  background: #f8fafc;
}
.cliente-reajuste-igpm-de-para-item strong,
.cliente-reajuste-igpm-de-para-item span {
  white-space: nowrap;
}
.cliente-reajuste-igpm-ajustes-card .uk-card-header {
  background: #fff;
}
.cliente-reajuste-igpm-ajustes-card .cadastro-empty-message {
  margin: 12px;
}
.cliente-reajuste-igpm-ajustes-table .uk-icon-button {
  width: 28px;
  height: 28px;
  margin-left: 4px;
}
.cliente-reajuste-igpm-preview-ajustes .uk-label {
  margin: 2px 4px 2px 0;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/pages/cadastros/clienteReajusteIgpm/index.less"],"names":[],"mappings":"AAAA;EAEQ,kBAAA;AAAR;AAFA;EAMQ,iBAAA;AADR;AAKA;EACI,aAAA;EACA,QAAA;EACA,gBAAA;AAHJ;AAMA;EACI,aAAA;EACA,QAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AAJJ;AADA;;EASQ,mBAAA;AAJR;AAQA;EAEQ,gBAAA;AAPR;AAKA;EAMQ,YAAA;AARR;AAYA;EAEQ,WAAA;EACA,YAAA;EACA,gBAAA;AAXR;AAeA;EAEQ,qBAAA;EACA,mBAAA;AAdR","sourcesContent":[".cliente-reajuste-igpm-preview {\n    .uk-label {\n        border-radius: 2px;\n    }\n\n    table {\n        min-width: 1320px;\n    }\n}\n\n.cliente-reajuste-igpm-de-para-list {\n    display: grid;\n    gap: 6px;\n    min-width: 220px;\n}\n\n.cliente-reajuste-igpm-de-para-item {\n    display: grid;\n    gap: 2px;\n    padding: 6px 8px;\n    border-left: 3px solid #003768;\n    background: #f8fafc;\n\n    strong,\n    span {\n        white-space: nowrap;\n    }\n}\n\n.cliente-reajuste-igpm-ajustes-card {\n    .uk-card-header {\n        background: #fff;\n    }\n\n    .cadastro-empty-message {\n        margin: 12px;\n    }\n}\n\n.cliente-reajuste-igpm-ajustes-table {\n    .uk-icon-button {\n        width: 28px;\n        height: 28px;\n        margin-left: 4px;\n    }\n}\n\n.cliente-reajuste-igpm-preview-ajustes {\n    .uk-label {\n        margin: 2px 4px 2px 0;\n        white-space: normal;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
